import React from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';

const Contact = () => {
  return (
    <FooterPageLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-grey-900 mb-6">Contact Us</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-semibold text-grey-900 mb-4">How Can We Help?</h2>
              <p className="text-grey-600 mb-6">
                Whether you have a question, found a bug, want to give feedback, or have a general inquiry, we're here to help. 
                Select your reason for contacting us below and we'll make sure your message gets to the right team.
              </p>
              
              <form className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-grey-700">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500"
                    placeholder="Enter your name"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-grey-700">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500"
                    placeholder="Enter your email"
                  />
                </div>
                
                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-grey-700">What can we help you with?</label>
                  <select
                    id="subject"
                    className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500"
                  >
                    <option value="">Select a topic</option>
                    <option value="bug">Report a Bug</option>
                    <option value="feedback">Give Feedback</option>
                    <option value="question">Ask a Question</option>
                    <option value="inquiry">General Inquiry</option>
                    <option value="partnership">Partnership Opportunity</option>
                    <option value="event">Host a Pebble Party (Events & Conferences)</option>
                  </select>
                </div>

                <div id="event-description" className="hidden text-sm text-grey-600 bg-grey-50 p-4 rounded-md">
                  <p className="mb-2">Interested in bringing Pebble to your event, conference, or festival? We partner with:</p>
                  <ul className="list-disc pl-4 space-y-1">
                    <li>Festivals & Conferences</li>
                    <li>Brands & Tech Ecosystem Builders</li>
                    <li>Event Venues & Spaces</li>
                  </ul>
                  <p className="mt-2">We'll work with you to create a customized experience, whether it's a panel discussion, networking mixer, fireside chat, or branded activation. Our team will help curate the perfect vibe for your event while showcasing how Pebble can add value to your attendees.</p>
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-grey-700">Your Message</label>
                  <textarea
                    id="message"
                    rows={4}
                    className="mt-1 block w-full rounded-md border-grey-300 shadow-sm focus:border-grey-500 focus:ring-grey-500"
                    placeholder="Tell us how we can help..."
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-[#B84141] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-[#923434] transition-colors"
                >
                  Send Message
                </button>
              </form>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-grey-900 mb-4">Other Ways to Connect</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="font-medium text-grey-900 mb-2">Email Support</h3>
                  <a 
                    href="mailto:support@pebbletheapp.com" 
                    className="flex items-center text-[#B84141] hover:text-[#923434] transition-colors"
                  >
                    <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    support@pebbletheapp.com
                  </a>
                  <p className="text-grey-600 mt-2">Response time: Within 24 hours</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-grey-900 mb-2">Business Hours</h3>
                  <p className="text-grey-600">Monday - Friday: 7:00 AM - 7:00 PM EST</p>
                </div>
                
                <div>
                  <h3 className="font-medium text-grey-900 mb-2">Follow Us</h3>
                  <div className="flex space-x-4">
                    <a href="https://www.facebook.com/pebbletheapp" target="_blank" rel="noopener noreferrer" className="text-grey-600 hover:text-[#B84141]">
                      <span className="sr-only">Facebook</span>
                      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                      </svg>
                    </a>
                    <a href="https://x.com/pebbletheapp" target="_blank" rel="noopener noreferrer" className="text-grey-600 hover:text-[#B84141]">
                      <span className="sr-only">X (Twitter)</span>
                      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>
                    </a>
                    <a href="https://www.instagram.com/pebbletheappofficial?igsh=MTB5cHk4aGJtdm54Zw==" target="_blank" rel="noopener noreferrer" className="text-grey-600 hover:text-[#B84141]">
                      <span className="sr-only">Instagram</span>
                      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </a>
                    <a href="https://www.linkedin.com/company/pebbletheapp/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-grey-600 hover:text-[#B84141]">
                      <span className="sr-only">LinkedIn</span>
                      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                      </svg>
                    </a>
                    <a href="https://youtube.com/@techloungepodcast?si=FDYcAQBFKd7xg-BB" target="_blank" rel="noopener noreferrer" className="text-grey-600 hover:text-[#B84141]">
                      <span className="sr-only">YouTube</span>
                      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FooterPageLayout>
  );
};

export default Contact; 